const QuizzesSection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">📝 Bài Kiểm Tra</h2>
            <p className="text-slate-700">
                Làm bài kiểm tra trực tuyến và theo dõi kết quả.
            </p>

            <div className="bg-white p-6 rounded-lg border border-slate-200">
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Cách làm bài kiểm tra:</h3>
                <ol className="list-decimal list-inside space-y-3 text-slate-700">
                    <li>Vào menu <strong>"Bài tập"</strong></li>
                    <li>Chọn bài kiểm tra muốn làm</li>
                    <li>Nhấn <strong>"Bắt đầu làm bài"</strong></li>
                    <li>Trả lời từng câu hỏi (có thể upload hình ảnh nếu cần)</li>
                    <li>Nhấn <strong>"Nộp bài"</strong> khi hoàn thành</li>
                    <li>Xem kết quả và đáp án ngay lập tức</li>
                </ol>
            </div>

            <div className="bg-green-50 p-6 rounded-lg border border-green-200">
                <h3 className="text-lg font-semibold text-green-900 mb-2">📊 Xem kết quả</h3>
                <ul className="text-slate-700 space-y-2">
                    <li>• <strong>Điểm số:</strong> Được tính tự động dựa trên đáp án đúng/sai</li>
                    <li>• <strong>Biểu đồ:</strong> Xem biểu đồ so sánh điểm qua các lần làm bài</li>
                    <li>• <strong>Lịch sử:</strong> Xem lại tất cả các lần đã làm bài</li>
                    <li>• <strong>Đáp án:</strong> Xem đáp án đúng và giải thích (nếu có)</li>
                </ul>
            </div>

            <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200">
                <h3 className="text-lg font-semibold text-yellow-900 mb-2">⚠️ Lưu ý</h3>
                <ul className="text-slate-700 space-y-2">
                    <li>• Một số bài có giới hạn thời gian - hãy làm nhanh!</li>
                    <li>• Không thể sửa đáp án sau khi nộp bài</li>
                    <li>• Đảm bảo kết nối internet ổn định khi làm bài</li>
                </ul>
            </div>
        </div>
    );
};

export default QuizzesSection;
